export default {
  estaCarregando: false,
  lista: [],
  parametros: '',
  contatosAtivo:[],
  contatosReceptivo:[],
  filtros: {
    idioma: '',
    curso: null,
    livro: null,
    instrutor: null
  }
}
